import React, { useMemo } from 'react';
import '../scss/button.scss';
import '../scss/form.scss'
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as AadharCard } from '../images/aadhar-card.svg'
import { ReactComponent as InfoIcon } from '../images/info-icon.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { ReactComponent as BetterInterest } from '../images/better-interest.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { useGenerateKycUrlMutation } from '../lib/services/kycApi';
import { generateChecksum } from '../lib/middleware/generateChecksum';
import { useDispatch, useSelector } from 'react-redux';
import { closeInfoModal, closeModal, openInfoModal, openModal, setError, toggleChecked } from '../lib/features/kycSlice';
import CenteredPopup from '../components/popups/CenteredPopup';
import { pushCleverTapEvent } from '../lib/middleware/CtEvents';

function CompleteKyc() {
    const dispatch = useDispatch()
    const { isChecked, isModalOpen, error, isInfoModalOpen } = useSelector((state) => state.kyc)
    const [generateKycUrl, { isLoading }] = useGenerateKycUrlMutation()
    const navigate = useNavigate()
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const modalButtons = [
        { label: 'Close', onClick: dispatch(closeModal()) }
    ]
    const redirectKyc = async () => {
        try {
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret');
            const consents = [
                {
                  consent_type: "DUE_DILIGENCE_WITH_RBI",
                  consent_status: isChecked ? "ACCEPTED" : "DECLINED",
                  consent_text: "I give my consent for Customer Due Diligence in terms of RBI Master Direction on Know Your Customer"
                }
            ];
            const consentsStr = JSON.stringify(consents)
            const checksum = generateChecksum({ mode: 'okyc_v2_get_data', consents: consentsStr })
            const result = await generateKycUrl({ checksum, jwt_token, scrt, consents: consentsStr }).unwrap()
            if (result && result.error) {
                dispatch(openModal())
                dispatch(setError(result.message))
            } else if (result.data && result.data.error) {
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    
                } else {
                    dispatch(openModal())
                    dispatch(setError(result.data.message))
                }
            } else if (result.data && result.data.message === 'Login expired! Please re-login.') {
                dispatch(openModal())
                dispatch(setError(result.data.message))
                localStorage.removeItem('jwt');
                localStorage.removeItem('lastVisitedPage');
                const phone = localStorage.getItem('phone')
                localStorage.clear()
                phone ? navigate(`/?phone=${phone}`) : navigate('/');
                
            } else {
                pushCleverTapEvent({
                    event_name: "web_adhaar_proceed", 
                    event_property: {
                        Source: window.localStorage.getItem('utm_source'),
                        Segment: localStorage.getItem('customerSegment'),
                    }});
                if (result && result.okyc_url) {
                    window.location.href = result.okyc_url
                } else if (result && !result.okyc_url && result.redirect_url) {
                    window.location.href = result.redirect_url
                }
            }
        } catch (error) {
            dispatch(setError('Something went wrong. Please try again later.'));
        }
    }
    return (
        <div className='external-wrapper'>
            <CenteredPopup
                isOpen={isModalOpen}
                buttons={modalButtons}
                onClose={() => dispatch(closeModal())} icon={<WarningIcon />}>
                <p>{error}</p>
            </CenteredPopup>
            <div className='page-content complete-your-kyc'>
                <PageHeader />
                <div className='aadhar-card'>
                    <AadharCard />
                </div>
                <div className='page-heading'>
                    <h2 className='page-title'>Complete your Aadhaar KYC</h2>
                    <p>in just 10 seconds</p>
                </div>
                <p className='info'><InfoIcon style={{ cursor: 'pointer' }} onClick={() => dispatch(openInfoModal())} /> Know More about <span className='red-text' style={{ cursor: 'pointer' }} onClick={() => dispatch(openInfoModal())}>Aadhaar KYC</span></p>
                <div className="timeline">
                    <div className="timeline-step">
                        <div className="timeline-content-left">Step-1</div>
                        <div className="timeline-node"></div>
                        <div className="timeline-content">Enter Aadhaar Number and Security Code</div>
                    </div>
                    <div className="timeline-line"></div>
                    <div className="timeline-step">
                        <div className="timeline-content-left">Step-2</div>
                        <div className="timeline-node"></div>
                        <div className="timeline-content">Create 4- Digit Share Code and Enter OTP</div>
                    </div>
                </div>
                <div className='better-interest-tag'>
                    <BetterInterest />
                    <p>Get better Interest rates with additional documents</p>
                </div>
                <div className='consent-check'><label><div className={`checkbox ${isChecked ? 'checked' : ''}`}><input type="checkbox" checked={isChecked} onChange={() => dispatch(toggleChecked(!isChecked))} /></div> <p>I give my consent for Customer Due Diligence in terms of <Link to="https://www.rbi.org.in/commonman/English/Scripts/Notification.aspx?Id=2607" target='_blank'>RBI Master Direction on Know Your Customer</Link></p></label></div>
                <div className='bottom-footer p-0'>
                    <p className='powered-by'>Powered by <StarfinLogo /></p>
                    <button type="button" className={`btn btn-primary ${!isChecked || isLoading ? 'disabled' : ''}`} onClick={redirectKyc}>Continue</button>
                </div>
            </div>
            <CenteredPopup
                className="kyc-modal"
                isOpen={isInfoModalOpen}
                onClose={() => dispatch(closeInfoModal())}>
                <h3>Aadhaar KYC</h3>
                <p>UIDAl has launched Aadhaar Paperless Offline e-KYC Verification to allow Aadhaar number holders to voluntarily use it for establishing their identity in paperless and electronic fashion, while still maintaining privacy, security and inclusion.<br />Aadhaar Paperless Offline e-KYC eliminates the need for residents to provide photo copy of Aadhaar letter and instead residents can download the KYC XML and provide the same for successful KYC verification. The KYC details is in machine readable XML which is digitally signed by UIDAl allowing StashFin to verify its authenticity and detect any</p>
            </CenteredPopup>
        </div>
    );
}

export default CompleteKyc;
